// extracted by mini-css-extract-plugin
export default {"wrapper":"RoundContainer_wrapper__tHf9l","pointer":"RoundContainer_pointer__gGTjm"};